import * as React from 'react';
import TablePagination from '@mui/material/TablePagination';
import { useTranslation } from 'react-i18next';
interface PropsValues {
  count: number;
  PageNumber: number;
  RowsPerPage: number; 
  setPage: (pageNumber: number) => void; 
  setRowsPerPage: (rowsPerPage: number) => void;
}

export default function Pagination({ count, PageNumber, RowsPerPage, setPage, setRowsPerPage }: PropsValues) {
  const { i18n, t } = useTranslation();
  
  const handleChangePage = (
    event: React.MouseEvent<HTMLButtonElement> | null,
    newPage: number,
  ) => {
    setPage(newPage); 
  };
  
  const handleChangeRowsPerPage = (
    event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>,
  ) => {
    const newRowsPerPage = parseInt(event.target.value, 10);
    setRowsPerPage(newRowsPerPage); 
    setPage(0); 
  };

  return (
    <TablePagination
      component="div"
      count={count}
      page={PageNumber}
      onPageChange={handleChangePage}
      rowsPerPage={RowsPerPage}
      onRowsPerPageChange={handleChangeRowsPerPage}
      rowsPerPageOptions={[10,15,50,100]}
      labelRowsPerPage={t('Rows Per Page')}
      labelDisplayedRows={({ from, to, count }) => `${from}-${to} ${t('of')} ${count}`}
    />
  );
}
